import config from "../../devprodConfig";

export async function giveUserAccessToKiinteisto(userId, kiinteistoId) {
  try {
    // 1️⃣ Get current assignments
    const res = await fetch(
      `${config.apiBaseUrl}/api/kayttaja-kiinteistot/user/${userId}`,
      { credentials: "include" }
    );

    if (!res.ok) throw new Error("Failed to fetch current assignments");

    const current = await res.json();
    const existingIds = current.map((k) => k.id_kiinteisto);

    
    const updatedIds = [...new Set([...existingIds, kiinteistoId])];

   
    const saveRes = await fetch(
      `${config.apiBaseUrl}/api/kayttaja-kiinteistot/user/${userId}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ kiinteistoIds: updatedIds }),
      }
    );

    if (!saveRes.ok) throw new Error("Failed to update assignments");
  } catch (err) {
    console.error("❌ giveUserAccessToKiinteisto failed:", err);
  }
}